import React from "react";

import classes from "./MessagesPage.module.css";
import pcariUser from "../../assets/svg/pcariMainToolBarLogo.svg"

const huminizeDate = (date) => {
    const delta = Math.round((+new Date() - date) / 1000);

    const minute = 60,
        hour = minute * 60,
        day = hour * 24;
    let fuzzy;

    if (delta < 30) {
        fuzzy = 'just now';
    } else if (delta < minute) {
        fuzzy = delta + ' seconds ago.';
    } else if (delta < 2 * minute) {
        fuzzy = 'a minute ago.'
    } else if (delta < hour) {
        fuzzy = Math.floor(delta / minute) + ' minutes ago.';
    } else if (Math.floor(delta / hour) === 1) {
        fuzzy = '1 hour ago.'
    } else if (delta < day) {
        fuzzy = Math.floor(delta / hour) + ' hours ago.';
    } else if (delta < day * 2) {
        fuzzy = 'yesterday';
    } else if (delta >= day * 2) {
        fuzzy = new Date(date).toString().slice(4, 15)
    }
    return fuzzy
}

const MessagesPage = (props) => {
    let messages = null
    if (props.messages) {
        messages = props.messages.data.map(chat => {
            const chatMessageLength = chat.chat_messages.length;
            let receiverId;
            try {
                receiverId = chat.chat_participants[0].id === +localStorage.getItem('uid') ?
                    chat.chat_participants[1].id
                    :
                    chat.chat_participants[0].id;
            } catch (error) {
                 receiverId = chat.chat_participants[0].id
            }
            // const receiverId = chat.chat_participants[0].id === +localStorage.getItem('uid') ?
            //     chat.chat_participants[1].id
            //     :
            //     chat.chat_participants[0].id;
            let receiverName = chat.chat_participants.filter(participant => participant.id === receiverId)[0].name;
            const lastMessage = chat.chat_messages[chatMessageLength - 1]
            const messageTime = new Date(lastMessage.created_at).getTime()
            const timeAgo = huminizeDate(messageTime)
            const chatUser = props.allUsers.filter(user => user.id === receiverId)[0];
            if (!receiverName) {
                receiverName = chatUser.email
            }
            return (
                <div
                    className={classes.Chat}
                    key={chat.id}
                    onClick={() => {
                        props.onCleanChat()
                        props.routeProp.push(`/Chat?with=${receiverId}&chat=${chat.id}`)
                    }}>
                    <div className={classes.Dealer}>
                        <img src={chatUser.profile_picture ? chatUser.profile_picture : pcariUser} alt='user pic' />
                        <h1>{receiverName}</h1>
                    </div>
                    <div className={classes.LatestMess}>
                        <p>
                            <label>{lastMessage.user_id === receiverId ? receiverName + ' :' : 'You :'}</label>
                            {lastMessage.message}
                        </p>
                        <label>{timeAgo}</label>
                    </div>
                </div>
            );
        })
    }
    return (
        <div className={classes.Container}>
            {messages}
        </div>
    );
};

export default MessagesPage;